<div class="button primary-color" (click)="returnToWebsite()">
  <svg xmlns="http://www.w3.org/2000/svg" width="21.333" height="15" viewBox="0 0 21.333 15">
    <path id="right-arrow"
      d="M14.365,4.9A.756.756,0,1,0,13.29,5.964l5.451,5.451H.753A.749.749,0,0,0,0,12.169a.757.757,0,0,0,.753.763H18.742L13.29,18.373a.772.772,0,0,0,0,1.075.753.753,0,0,0,1.075,0l6.742-6.742a.74.74,0,0,0,0-1.064Z"
      transform="translate(21.333 19.674) rotate(180)" fill="#1ead8b" />
  </svg>
  <span class="d-none d-lg-inline-block text"> &nbsp; Revenir à spbfamily.eu</span>
</div>

<img src="./assets/spbfamily/home_bg.jpg" [hidden]='true' (load)='ImgLoaded = true'>

<ng-container *ngIf='ImgLoaded'>
  <app-side-cookie-modal></app-side-cookie-modal>
  <app-hero-header></app-hero-header>
  <app-testimonials-header></app-testimonials-header>
  <app-assurence-expo></app-assurence-expo>
  <app-comparison-table></app-comparison-table>
  <app-spbf-granties></app-spbf-granties>
  <app-footer></app-footer>
</ng-container>


<ng-container *ngIf='!ImgLoaded'>
  <div class="spinner-wrapper">

    <div class="center-box">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

  </div>
</ng-container>